/**
 * Checkbox Component
 */

import React, { FC, useState } from 'react';
import { CheckboxProps, CheckboxType } from './checkbox.types';
import { Pill, HiddenCheckbox, Wrapper } from './checkbox.style';
import Check from './check';
import generateId from '../../utils/generateId';

const Checkbox: FC<CheckboxProps> = (props: CheckboxProps) => {

  const {
    label,
    className,
    id,
    idPrefix = 'mlb-checkbox-',
    name,
    value,
    checked,
    defaultChecked,
    handlers = {},
    dataAttr = {},
    type = CheckboxType.PILL,
    disabled = false,
  } = props;
  const [checkboxId] = useState(id || generateId(idPrefix));

  const Component = type === CheckboxType.CHECKBOX ? Check : Pill;
  return (
    <Wrapper className={className}>
      <HiddenCheckbox
          id={checkboxId}
          name={name}
          value={value}
          checked={checked}
          defaultChecked={defaultChecked}
          disabled={disabled}
          {...handlers}
          {...dataAttr}
        />
        <Component htmlFor={checkboxId} disabled={disabled}>
          {label}
        </Component>
    </Wrapper>
  );
};

export default Checkbox;
